var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.editor)?_c('div',{staticClass:"editor"},[_c('EditorMenuBar',{staticClass:"editor__header",attrs:{"editor":_vm.editor}}),_c('editor-content',{staticClass:"editor__content",attrs:{"editor":_vm.editor}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }